import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { Role } from "@App/types/ayvens/role";
import type { FleetManagerSuccessResponse } from "@App/apis/rest/ayvens/driverData/responses/fleetManagerSuccessResponse";
import type { DriverDataSuccessResponse } from "@App/apis/rest/ayvens/driverData/responses/driverDataSuccessResponse";

interface AuthReducerState {
  userId: string | null;
  initialRole: Role | null;
  role: Role | null;
  fleetManagerData: FleetManagerSuccessResponse | null;
  driverData: DriverDataSuccessResponse | null;
  initialToken: string | null;
  token: string | null;
}

const initialState: AuthReducerState = {
  userId: null,
  initialRole: null,
  role: null,
  fleetManagerData: null,
  driverData: null,
  initialToken: null,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string | null>) => {
      state.userId = action.payload;
    },
    setFleetManagerData: (state, action: PayloadAction<FleetManagerSuccessResponse | null>) => {
      state.fleetManagerData = action.payload;
    },
    setDriverData: (state, action: PayloadAction<DriverDataSuccessResponse | null>) => {
      state.driverData = action.payload;
    },
    setInitialRole: (state, action: PayloadAction<Role | null>) => {
      state.initialRole = action.payload;
    },
    setRole: (state, action: PayloadAction<Role | null>) => {
      state.role = action.payload;
    },
    setInitialToken: (state, action: PayloadAction<string | null>) => {
      state.initialToken = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
  },
});

export const {
  setUserId,
  setFleetManagerData,
  setDriverData,
  setInitialRole,
  setRole,
  setInitialToken,
  setToken,
} = authSlice.actions;

export default authSlice.reducer;
